export class CacheStatus {
  cacheDate: number;
  cacheEnabled: boolean;
}
